import React from 'react';

const Payment = ({ rowData }) => {
    return (
        <span>  
            {rowData.amount < 0 ? (  
                <>
                    <span style={{color: '#909090'}}>
                        {Number.isNaN(Number(rowData.amount))
                        ? `${Math.abs(rowData.amount)}-`
                        : `${Number(Math.abs(rowData.amount)).toLocaleString()}-`}<br/>
                    </span>
                </>
            ) : (  
                <>
                    <span style={{color: '#32de84'}}>
                        {Number.isNaN(Number(rowData.amount))
                        ? `${rowData.amount}+`
                        : `${Number(rowData.amount).toLocaleString()}+`}<br/>
                    </span>
                </>
            )}  
        </span>  
    );
}

export default Payment;